var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('QS-h4-title',{attrs:{"title":"紧急联系人"}}),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('QS-column-box',{key:index,attrs:{"source":item,"column":3,"labelWidth":"150","separator":":","list":_setup.emergencyContactConf}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }